import TiktokForm from "./tiktokForm.container";

export default TiktokForm;
